module.exports = __webpack_public_path__ + "static/assets/77a7bc97dc9994b9dffc90548efaa7d0.svg";